export default __webpack_public_path__ + "static/media/3-Livro-Estrelas-de-Couro-2.d1c832c5.jpg";